/**
 * Manufacturer Types
 * TypeScript interfaces for the Manufacturers CRUD feature
 */

export interface ManufacturerItem {
  id: number;
  manufacturerName: string;
  modelName?: string | null;
  status: number;
  isDc: boolean;
  isOcppTariff: boolean;
  isOcppCost: boolean;
  priceTextTemplate?: string | null;
  priceTextOfflineTemplate?: string | null;
  finalCostPriceTextTemplate?: string | null;
  createdBy?: number | null;
  createdByName?: string | null;
  updatedBy?: number | null;
  updatedByName?: string | null;
  created: string;
  updated: string;
}

export interface CreateManufacturerRequest {
  manufacturerName: string;
  modelName?: string | null;
  status: number;
  isDc: boolean;
  isOcppTariff: boolean;
  isOcppCost: boolean;
  priceTextTemplate?: string | null;
  priceTextOfflineTemplate?: string | null;
  finalCostPriceTextTemplate?: string | null;
}

export interface UpdateManufacturerRequest {
  id: number;
  manufacturerName?: string | null;
  modelName?: string | null;
  status?: number | null;
  isDc?: boolean | null;
  isOcppTariff?: boolean | null;
  isOcppCost?: boolean | null;
  priceTextTemplate?: string | null;
  priceTextOfflineTemplate?: string | null;
  finalCostPriceTextTemplate?: string | null;
}

export interface PriceTextPlaceholder {
  key: string;
  description: string;
  example?: string;
  source?: string;
}

export interface ManufacturerResponse {
  value: ManufacturerItem[];
  '@odata.count'?: number;
  availablePlaceholders?: PriceTextPlaceholder[];
  exampleTemplates?: string[];
  finalCostExampleTemplates?: string[];
}

// Status enum for UI display
export enum ManufacturerStatus {
  Inactive = 0,
  Active = 1,
}

export const ManufacturerStatusLabels: Record<ManufacturerStatus, string> = {
  [ManufacturerStatus.Inactive]: 'Inactive',
  [ManufacturerStatus.Active]: 'Active',
};
